(function () {

  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

})();
// Hide "Financing Available" rows in specs tables for Canada only
document.addEventListener('DOMContentLoaded', function() {
  const marketElement = document.querySelector('[data-market]');
  const isCanada = marketElement && marketElement.getAttribute('data-market') === 'canada';
  
  if (isCanada) {
    const rows = document.querySelectorAll('table tr, .table tr');
    rows.forEach(row => {
      const cells = row.querySelectorAll('td, th');
      for (let cell of cells) {
        if (cell.textContent.includes('Financing Available')) {
          row.style.display = 'none';
          break;
        }
      }
    });
  }
});